import { useState } from "react";
import { DashboardUtils } from "../../../dashboard_utils";
import { trpc } from "../../../utils/trpc";
import { DashboardContainer } from "../base_components/dashboard_container";
import { SeshAddonInput } from "../base_components/sesh_addon_input";
import { useQueryParams } from "../hooks/use_query_params";
import { AdminEntityViewer } from "./admin_entity_viewer";
import { AdminLogsViewer } from "./admin_logs_viewer";
import { AdminSeshStats } from "./admin_sesh_stats_viewer";
import { AdminStatusPage } from "./admin_status_page";
import { AdminStripeManager } from "./admin_stripe_manager";
import { AdminWaitlistManager } from "./admin_waitlist_manager";
import { AdminShardsViewer } from "./admin_shards_viewer";
import { AdminBlurbManager } from "./admin_blurb_manager";

const tabs = {
	Entities: <AdminEntityViewer />,
	Stripe: <AdminStripeManager />,
	Status: <AdminStatusPage />,
	Waitlist: <AdminWaitlistManager />,
	Logs: <AdminLogsViewer />,
	Stats: <AdminSeshStats />,
	Shards: <AdminShardsViewer />,
	Blurbs: <AdminBlurbManager />,
};

export function AdminPage() {
	const is_admin_query = trpc.admin.isSeshAdmin.useQuery();

	let { tab: tab_from_url } = useQueryParams<{
		tab: keyof typeof tabs;
	}>();

	const [tab, setTab] = useState<keyof typeof tabs>(
		tab_from_url ?? "Entities"
	);

	if (is_admin_query.isError) {
		return (
			<DashboardUtils.RenderDashboardErrorPage
				text="Must be admin to view this page"
				title="UNAUTHORIZED"
			/>
		);
	}

	if (!is_admin_query.isSuccess) {
		return <DashboardUtils.RenderFullLoadingThrobberPage />;
	}

	return (
		<DashboardContainer title={"Admin"}>
			<div className="flex flex-col">
				<div className="mb-12 ml-auto">
					<SeshAddonInput
						buttons={Object.keys(tabs).map(
							(val: keyof typeof tabs) => ({
								label: val,
								value: val,
							})
						)}
						setValue={(tab) => {
							setTab(tab);

							const search_params = new URLSearchParams();
							search_params.append("tab", tab);

							window.history.pushState(
								{},
								null,
								`/dashboard/admin?${search_params}`
							);
						}}
						value={tab}
					/>
				</div>
				{tabs[tab]}
			</div>
		</DashboardContainer>
	);
}
